import { Service, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, map, merge } from 'rxjs';

@Service()
export class ConnectionService {
  private readonly _isOnline = signal(navigator.onLine);

  public readonly isOnline = this._isOnline.asReadonly();

  constructor() {
    merge(
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false)),
    )
      .pipe(takeUntilDestroyed())
      .subscribe((online) => this._isOnline.set(online));
  }

  public retryConnection(): void {
    this._isOnline.set(navigator.onLine);
  }
}
